module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Discount Rate Comparison",
      "set-position": "relative",
      "create-button": true,
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-discount-rate-comparison"
  }, [(!_vm.processing) ? _c('div', [_c('page-form'), _vm._v(" "), _c('br'), _c('hr'), _c('br'), _vm._v(" "), (_vm.preview.data.length) ? _c('claims-preview') : _c('div', [_vm._v("\n                No matching claims match your search criteria. Please update your \n                search criteria and perform another preview.\n            ")])], 1) : _c('div', [_c('h2', {
    staticClass: "u-padding-b-30"
  }, [_vm._v("\n                Processing Discount Rates\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Your discount rates are currently being processed"), _c('br'), _c('br'), _vm._v("\n                " + _vm._s(_vm.progress.numberCompleted) + " claims have been updated out of " + _vm._s(_vm.progress.numberOfClaims) + " "), _c('br'), _c('br'), _vm._v("\n                Please check back soon.\n            ")]), _vm._v(" "), _c('progress-bar', {
    attrs: {
      "value": _vm.progress.numberCompleted,
      "total-value": _vm.progress.numberOfClaims
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3102d32d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/UpdateDiscountRate.vue
// module id = 1630
// module chunks = 0